var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("neu-cards-slider2", {
        staticClass: "section py-lg-5 py-0  mx-auto",
        attrs: {
          cards: _vm.cards,
          blackTitle: _vm.$t("abogalitypro.cards.title"),
          title: _vm.$t("abogalitypro.cards.subtitle"),
          iconsColor: _vm.ORANGE_COLOUR
        }
      }),
      _vm._v(" "),
      _c(
        "base-button",
        {
          staticClass: "btn mx-auto",
          staticStyle: { "margin-bottom": "5rem", display: "block" },
          attrs: { blue: "", outline: "" },
          on: { click: function() {} }
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("abogalitypro.register-for-free")))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2abef76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2abef76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/abogalitypro/AbogalityCardsSlider.vue
// module id = 4132
// module chunks = 10